import { useContext } from 'react';

import {
  CurrentNetworkContext,
  CurrentUserContext,
} from 'hb-react/frontoffice/contexts/DefaultAppContexts';

export const useCurrentNetwork = () => useContext(CurrentNetworkContext);

export const useCurrentUser = () => useContext(CurrentUserContext);
